import type { AnyObject } from 'antd/es/_util/type'
import { default as queryString, type ParseOptions } from 'query-string'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const DEFAULT_OPTIONS: ParseOptions = { arrayFormat: 'comma' }

export const useQueryParams = (
  options: ParseOptions = DEFAULT_OPTIONS
): AnyObject => {
  const { search } = useLocation()

  const params = useMemo(
    () => queryString.parse(search, options),
    [search, options]
  )

  return params
}
